<template>
  <div class="tva-slider">
    <div class="tva-slider-container" ref="slider">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Flickity from "flickity-imagesloaded";
import _ from "lodash";
export default {
  props: {
    config: { type: Object, default: null },
    fade: { type: Boolean, default: false },
    groupSize: { default: 3 },
    mobile: { type: Boolean },
    dataset: { type: Object },
    options: {
      type: Object,
      default: () => {
        return {
          draggable: ">1",
          prevNextButtons: false,
          pageDots: false,
          imagesLoaded: true,
          lazyLoad: true,
          adaptiveHeight: true,
          fade: false,
          inistialIndex: 0,
          cellAlign: "left"
        };
      }
    }
  },
  data() {
    return {
      isFlickity: false,
      elementsCount: 0,
      slideGroups: [],
      index: 0,
      cards: []
    };
  },
  created() {
    this.options.fade = this.fade;
    this.index = 0;
    if (this.config) {
      _.forEach(this.config, (value, key) => {
        this[key] = value;
      });
    }
    this.options.cellAlign = this.$tvaMq === "desktop" ? "left" : "center";
  },
  mounted() {
    this.$nextTick(() => {
      this.cards = new Array(this.$refs.slider.childElementCount).fill(0);
      this.elementsCount = this.$refs.slider.childElementCount;
      this.createFlickity();
      /*  if (!this.mobile) {
        this.flkty.next();
      } */
      window.addEventListener("resize", () => {
        this.createFlickity();
      });
    });
  },
  methods: {
    createFlickity() {
      var elem = this.$refs.slider;
      if (elem && !this.isFlickity) {
        this.flkty = new Flickity(elem, this.options);
        this.flkty.on("change", (index) => {
          this.index = index;
          this.$emit("sliderChange", index);
        });
        this.flkty.on("dragStart", () =>
          this.flkty.slider.childNodes.forEach(
            (slide) => (slide.style.pointerEvents = "none")
          )
        );
        this.flkty.on("dragEnd", () =>
          this.flkty.slider.childNodes.forEach(
            (slide) => (slide.style.pointerEvents = "all")
          )
        );
        this.isFlickity = true;
      } else if (!elem && this.isFlickity) {
        this.flkty.destroy();
        this.flkty = null;
        this.isFlickity = false;
      }
    },
    goTo(index) {
      this.flkty.select(index);
    },
    goPrevious() {
      if (this.index > 0) {
        this.flkty.previous();
      }
    },
    goNext() {
      if (this.index < this.elementsCount - 1) {
        this.flkty.next();
      }
    }
  },
  watch: {
    dataset() {
       this.flkty.destroy();
        this.flkty = null;
        this.isFlickity = false;
        setTimeout(()=>{this.createFlickity()},0);
        
    }
  }
};
</script>

<style lang="scss" scoped>
img {
  height: 100%;
}

.tva-slider-container,
.tva-dots,
.tva-slider {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  .tva-dots {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
    z-index: $z-a;
    cursor: pointer;
    position: absolute;
    bottom: 10px;
    /* .tva-dot {
      border-radius: 50%;
      background: $gray-2;
      width: 10px;
      height: 10px;
      margin: 5px;
      &-selected {
        background: $gray-5;
      }
      &:last-of-type {
        margin-right: 0 !important;
      }
    } */
  }
}
</style>

<style lang="scss">
/*! Flickity v2.2.0
https://flickity.metafizzy.co
---------------------------------------------- */

.flickity-enabled {
  position: relative;
}

.flickity-enabled:focus {
  outline: none;
}

.flickity-viewport {
  height: 100% !important;
  overflow: visible;
  position: relative;
  width: 100%;
}

.flickity-slider {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: initial;
}

/* draggable */

.flickity-enabled.is-draggable {
  -webkit-tap-highlight-color: transparent;
  tap-highlight-color: transparent;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.flickity-enabled.is-draggable .flickity-viewport {
  cursor: move;
  cursor: -webkit-grab;
  cursor: grab;
}

.flickity-enabled.is-draggable .flickity-viewport.is-pointer-down {
  cursor: -webkit-grabbing;
  cursor: grabbing;
}
</style>
